export default class Videos{
    constructor(){
        this.videos = document.querySelectorAll('.video');
        if (this.videos){
            this.init(); 
        }
    }
    
    init() {
        this.videos.forEach(video => {
            let isPaused = true;
            let videoEl = video.querySelector('video');
            let overlay = video.querySelector('.overlay');

            
            overlay.addEventListener('click', () => {
                if (videoEl.paused){
                    videoEl.play();    
                }else{ 
                    videoEl.pause();
                }
            });

            videoEl.addEventListener('play', ()=>{
                video.classList.add('playing');
                video.classList.remove('paused');
            });

            videoEl.addEventListener('pause', ()=>{
                video.classList.remove('playing');
                video.classList.add('paused');
            });


            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) {
                    videoEl.pause();
                  } else {
                    videoEl.play();
                  }
                });
              }, {});
              observer.observe(video);
        });
    }
}